// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__6DQjF","info":"UpdateTermsInfo_info__1J97o"};